export interface CategorizedSlots {
  morning: Array<{
    originalTime: string;
    convertedTime: string;
    displayTime: string;
  }>;
  afternoon: Array<{
    originalTime: string;
    convertedTime: string;
    displayTime: string;
  }>;
  evening: Array<{
    originalTime: string;
    convertedTime: string;
    displayTime: string;
  }>;
}

/**
 * Categorize timeslots into morning, afternoon, and evening periods
 * Morning: 6:00 AM - 11:59 AM
 * Afternoon: 12:00 PM - 5:59 PM  
 * Evening: 6:00 PM - 11:59 PM
 */
export function categorizeTimeSlots(slots: Array<{
  originalTime: string;
  convertedTime: string;
  displayTime: string;
}>): CategorizedSlots {
  const categorized: CategorizedSlots = {
    morning: [],
    afternoon: [],
    evening: []
  };

  slots.forEach(slot => {
    // Extract hour from the converted time (24-hour format)
    const timeMatch = slot.convertedTime.match(/^(\d{1,2}):(\d{2})/);
    if (!timeMatch) {
      // Fallback: try to parse display time
      const displayMatch = slot.displayTime.match(/(\d{1,2}):(\d{2})\s*(am|pm)/i);
      if (displayMatch) {
        let hour = parseInt(displayMatch[1]);
        const isPM = displayMatch[3].toLowerCase() === 'pm';
        if (isPM && hour !== 12) hour += 12;
        if (!isPM && hour === 12) hour = 0;
        
        if (hour >= 6 && hour < 12) {
          categorized.morning.push(slot);
        } else if (hour >= 12 && hour < 18) {
          categorized.afternoon.push(slot);
        } else if (hour >= 18 || hour < 6) {
          categorized.evening.push(slot);
        }
      }
      return;
    }

    const hour = parseInt(timeMatch[1]);
    
    if (hour >= 6 && hour < 12) {
      categorized.morning.push(slot);
    } else if (hour >= 12 && hour < 18) {
      categorized.afternoon.push(slot);
    } else if (hour >= 18 || hour < 6) {
      categorized.evening.push(slot);
    }
  });

  return categorized;
}

/**
 * Get the appropriate icon and label for each time period
 */
export function getTimePeriodInfo(period: 'morning' | 'afternoon' | 'evening') {
  switch (period) {
    case 'morning':
      return {
        label: 'Morning',
        icon: '🌅' // We'll replace this with React icons in the component
      };
    case 'afternoon':
      return {
        label: 'Afternoon', 
        icon: '☀️'
      };
    case 'evening':
      return {
        label: 'Evening',
        icon: '🌆'
      };
  }
} 